import moment from 'moment';
import DatePicker from 'react-datepicker';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { NumericFormat } from 'react-number-format';
import { useEnv } from '../../../../context/env-context';
import { useAuth } from '../../../../hooks/useAuth';
import { makeRequest } from '../../../../utils/makeRequest';
import { toast } from 'react-toastify';

function ReportProfitabilityModalForm({ setSpinner, close, createReport }) {
  const { apiOriginOrchestrator } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [dateFrom, setDateFrom] = useState(moment().startOf('year').format('YYYY-MM-DD'));
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [monthlySubscriptionFee, setMonthlySubscriptionFee] = useState(0);

  const getMonthlyRevenue = async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    setSpinner(true);
    const config = {
      token,
      url: `${apiOriginOrchestrator}/get_setting?key=prMonthlyRevenue`,
      method: 'GET',
      params: { category: 'SURVEY' },
    };

    try {
      const response = await makeRequest(config);

      setMonthlySubscriptionFee(response.value);
    } catch (error) {
      toast.error(`Failed getting survey types: ${error.message}`);
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getMonthlyRevenue();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () =>
    createReport({
      from: moment(dateFrom).format('YYYY-MM-DD'),
      to: moment(dateTo).format('YYYY-MM-DD'),
      monthlySubscriptionFee,
    });

  return (
    <>
      <div>
        <Row className="align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>From:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <DatePicker
              className="bo-input bo-date-picker bo-w-250"
              onChange={e => setDateFrom(e)}
              selected={new Date(dateFrom)}
              dateFormat="yyyy-MM-dd"
              customInput={<Form.Control />}
            />
          </Col>
        </Row>
        <Row className="mt-2 mb-2 align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>To:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <DatePicker
              className="bo-input bo-date-picker bo-w-250"
              onChange={e => setDateTo(e)}
              selected={new Date(dateTo)}
              dateFormat="yyyy-MM-dd"
              customInput={<Form.Control />}
            />
          </Col>
        </Row>
        <Row className="mt-2 mb-2">
          <Col md={4} className="bo-same-line">
            <Form.Label>Monthly Subscription Fee:</Form.Label>
          </Col>
          <Col md={8}>
            <NumericFormat
              className="bo-input bo-w-250"
              value={monthlySubscriptionFee}
              onValueChange={({ floatValue }) => setMonthlySubscriptionFee(floatValue)}
              customInput={Form.Control}
            />
          </Col>
        </Row>
      </div>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button
            className="bo-button"
            onClick={handleCreate}
            disabled={!dateFrom && !dateTo && !monthlySubscriptionFee}
          >
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportProfitabilityModalForm;
